import * as React from "react";
const MoppingIcon = (props) => (
    <svg
        width={24}
        height={15}
        viewBox="0 0 24 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.67569 10.0847L4.79709 10.2694C4.98833 10.6376 5.07777 11.0496 5.05326 11.4662C4.95163 13.1589 3.10738 14.1508 1.63744 13.3042C0.551841 12.6741 0.176089 11.285 0.805371 10.1924C0.805437 10.1923 0.805504 10.1922 0.80557 10.1921L2.64985 7.00254L4.67569 10.0847Z"
            stroke="white"
            strokeMiterlimit={10}
        />
        <path
            d="M10.8222 10.0847L10.9436 10.2694C11.1348 10.6376 11.2243 11.0496 11.1997 11.4662C11.0981 13.1589 9.25386 14.1508 7.78392 13.3042C6.69833 12.6741 6.32257 11.285 6.95186 10.1924C6.95192 10.1923 6.95199 10.1922 6.95205 10.1921L8.79634 7.00254L10.8222 10.0847Z"
            stroke="white"
            strokeMiterlimit={10}
        />
        <path
            d="M16.9706 10.0847L17.092 10.2694C17.2833 10.6376 17.3727 11.0496 17.3482 11.4662C17.2466 13.1589 15.4023 14.1508 13.9324 13.3042C12.8468 12.6741 12.471 11.285 13.1003 10.1924C13.1004 10.1923 13.1004 10.1922 13.1005 10.1921L14.9448 7.00254L16.9706 10.0847Z"
            stroke="white"
            strokeMiterlimit={10}
        />
        <path
            d="M23.1171 10.0847L23.2385 10.2694C23.4297 10.6376 23.5192 11.0496 23.4947 11.4662C23.393 13.1589 21.5488 14.1508 20.0788 13.3042C18.9932 12.6741 18.6175 11.285 19.2468 10.1924C19.2468 10.1923 19.2469 10.1922 19.247 10.1921L21.0913 7.00254L23.1171 10.0847Z"
            stroke="white"
            strokeMiterlimit={10}
        />
        <path
            d="M0.566406 3.70312L23.4333 3.70312"
            stroke="white"
            strokeLinecap="square"
        />
        <path
            d="M0.566406 0.886719L23.4333 0.886719"
            stroke="white"
            strokeLinecap="square"
        />
    </svg>
);
export default MoppingIcon;